export var UPDATE_BRAND = { type: "BrandActions_UpdateBrand" };
export var updateBrand = function () {
    return {
        type: UPDATE_BRAND
    };
};
export default {
    updateBrand: updateBrand
};
